import styled from 'styled-components';
import ds from 'designsystem';
import { media } from 'designsystem/index';

const CardWrapper = styled.div`    
    display: flex;
    flex-flow: row;
    width:100%;
    ${media.desktop`
        width:125%;
        position: absolute;
        top: ${ds.get('metrics.l')};
        transform: scale(1);
        transition: transform 0.5s ease;
        transform-origin: 0 50%;
        & > div .slick-list{
            overflow: visible;
            & .slick-track{
                margin-left:0;
            }
        }
        &:hover{
            transform: scale(0.98, 1);
            transform-origin: 0 50%;
            transition: transform 0.5s ease;
            cursor:pointer;
        }
    `};
`;

export default CardWrapper;



// WEBPACK FOOTER //
// ./src/kentico-blocks/CardSlider/CardWrapper.jsx